export const configProd = {
    resourcehost: "https://career-api.devstack.com.au/",
    apihost: "https://career-api.devstack.com.au/api/v1/",
    reCaptchaSiteKey: '6Lc6apIUAAAAAHY0YGO0hNCkg7FavcZ-VMh0ZoGX',
    reCaptchaSekretKey: '6Lc6apIUAAAAAF9js9VyWdrGDQcjx7Kmt75lIJ4L',
    resourceIPHost: "https://career-api.devstack.com.au/"
}


// WEBPACK FOOTER //
// ./src/config/config.prod.js